// general style themes to be imported into styled components

export const fontFamily = {
  baseFont: 'Montserrat, sans-serif',
};

export const breakpoints = {
  desktop: '826px',
  mobile: '827px',
};

export const colours = {
  yellow: '#fff000',
  white: '#ffffff',
  grey: '#C4C4C4',
  black: '#000000',
  transparentGrey: 'rgba(196, 196, 196, 0.3)',
};

export const borders = {
  dashed: `1px dashed ${colours.black}`,
  yellow: `1px solid ${colours.yellow}`,
  black: `1px solid ${colours.black}`,
};

export const fontSize = {
  big: '2.75em',
  medium: '2em',
  small: '1.2em;',
  tiny: '1em',
  mobile: '1.5em',
  drawer: '5vh',
};

export const spacing = {
  massive: '3.5em',
  big: '2.75em',
  medium: '2em',
  small: '1.25em',
  tiny: '0.5em',
};
